import React from "react";
import { AuthenticationFlow } from "../components/AuthenticationFlow";

export const LoginPage: React.FC = () => {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-slate-50 px-4 sm:px-8 lg:px-12 py-10">

      {/* Main Card Container - left & right sections */}
      <div className="w-full max-w-8xl min-h-[85vh] bg-white rounded-[40px] shadow-[0_32px_80px_rgba(15,23,42,0.35)] flex flex-col lg:flex-row items-stretch overflow-hidden">
        {/* Left Side - Branding with Fluid Art Background */}
        <div className="flex w-full min-h-[40vh] lg:w-1/2 relative overflow-hidden bg-slate-900 shrink-0">
          {/* Fluid Art Background */}
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url("https://preview.redd.it/fluid-art-emptiness-abstract-background-v0-y71tl4wvh31f1.jpeg?width=1080&crop=smart&auto=webp&s=2d2dd2606334a866069f87b1aa9bc0370bf232f4")`,
            }}
          ></div>

          {/* Overlay for better text readability */}
          <div className="absolute inset-0 bg-linear-to-b from-slate-900/70 via-slate-900/30 to-slate-900/85"></div>

          {/* Content */}
          <div className="relative z-10 h-full w-full flex flex-col justify-center lg:justify-between px-6 py-8 lg:px-10 lg:py-12 text-white">
            {/* Top section - Logo and Welcome */}
            <div className="w-full flex flex-col items-center text-center">
            <img
                    src="https://ik.imagekit.io/rtm128ziu/ibdiclogo%20(1).png"
                    alt="IBDIC Logo"
                    className="w-auto h-16 lg:h-24 drop-shadow-[0_10px_25px_rgba(15,23,42,0.6)] object-contain"
                  />
              <h1 className="itn-h1 text-white mb-3 tracking-tight text-center">
                Welcome to IBDIC
              </h1>
              <p className="itn-body-3 text-white/85 text-center">
                Secure Access Gateway
              </p>
            </div>

            {/* Middle section - Description - Hidden on mobile to save space */}
            <div className="hidden lg:flex w-full items-center justify-center flex-1 pt-10">
              <div className="max-w-md text-center">
                <p className="text-lg text-white/90 leading-relaxed">
                  A unified digital trade platform empowering domestic and international trade
                </p>
              </div>
            </div>

            {/* Footer Info - Hidden on mobile */}
            <div className="hidden lg:flex w-full items-center justify-center pb-4">
              <div className="backdrop-blur-xl bg-white/10 border border-white/20 rounded-full px-6 py-2">
                <p className="text-sm text-white/80">
                  © 2025 IBDIC. All rights reserved.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Login Form */}
        <div className="w-full lg:w-1/2 flex flex-col bg-white">
          {/* Header for mobile - Simplified */}
          <header className="lg:hidden px-6 pt-6 pb-2">
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium text-slate-500">
                IBDIC Portal
              </span>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
                <span className="text-xs font-medium text-slate-600 uppercase tracking-wider">
                  Secure
                </span>
              </div>
            </div>
          </header>

          {/* Main Content */}
          <main
            id="main-content"
            className="flex-1 flex items-center justify-center px-6 lg:px-10 py-8"
            role="main"
          >
            <div className="w-full max-w-md space-y-6">
              <div className="px-1">
                <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400 mb-2">
                  Sign in
                </p>
                <h2 className="itn-h3 font-medium text-slate-900 mb-1 flex items-center">
                  IBDIC | 
                  <img 
                    src="https://ik.imagekit.io/rtm128ziu/OneTrade%20Logo.png" 
                    alt="Logo" 
                    className="h-6 w-auto ml-2" 
                  />
                </h2>
              </div>

              <div>
                <AuthenticationFlow />
              </div>

              {/* <div className="text-center space-y-3 max-w-md mx-auto">
                <p className="itn-body-4 text-slate-500 px-2">
                  By signing in, you agree to our{" "}
                  <a
                    href="#"
                    className="text-indigo-600 underline hover:text-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1 rounded"
                    onClick={(e) => {
                      e.preventDefault();
                      alert("Terms of service would be displayed here.");
                    }}
                    aria-label="View terms of service"
                  >
                    terms of service
                  </a>{" "}
                  and{" "}
                  <a
                    href="#"
                    className="text-indigo-600 underline hover:text-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1 rounded"
                    onClick={(e) => {
                      e.preventDefault();
                      alert("Privacy policy would be displayed here.");
                    }}
                    aria-label="View privacy policy"
                  >
                    privacy policy
                  </a>
                  .
                </p>
              </div> */}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};
